import downloadCertificate from './PrintCertificate';
import Create from './Create';
import Delete from './Delete';
import Update from './Update';
import UpdateUnique from './UpdateUnique';

import Cracha from './Cracha';

import CrachaLote from './CrachaLote';
import QrCode from './QrCode';
import Credenciar from './Credenciar';


import ChangeCrachaConfig from './ChangeCrachaConfig';
import UploadStudents from './UploadStudents';
import Balls from './Balls';

import CreateParticipant from './CreateParticipant';

const lineModules = {
    create: Create,
    delete: Delete,
    update: Update,
    updateUnique: UpdateUnique,
    downloadCertificate: downloadCertificate,

    cracha: Cracha,
    crachaLote: CrachaLote,
    qrCode: QrCode,
    credenciar: Credenciar,
 createParticipant: CreateParticipant,
    ChangeCrachaConfig: ChangeCrachaConfig,
    UploadStudents: UploadStudents,
    Balls: Balls,
}

export default lineModules;